const base = process.env.PUBLIC_URL ?? "";
// eslint-disable-next-line import/prefer-default-export
export const getUri = (uri) => base.toString() + uri.toString();
